import React from "react";
import useIsMobile from "../../common/hooks/useIsMobile";

function Icon() {
  const isMobile = useIsMobile();

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={!isMobile ? "10vw": "36vw"}
      height={!isMobile ? "10vw": "36vw"}
      fill="none"
      viewBox="0 0 156 171"
    >
      <path
        stroke="#575757"
        strokeWidth="2"
        d="M147.2 85.5v1h7.8v75.727h-7.8V170H8.8v-7.773H1V86.5h7.8v-7.773h23.4V32.091H40V16.545h7.8V8.774h15.6V1h29.2v7.773h15.6v7.773h7.8V32.09h7.8v46.636h23.4V85.5zm-45.8-6.773h1V30.091h-7.8v-7.773H61.4v7.773h-7.8v48.636h47.8z"
      ></path>
    </svg>
  );
}

export default Icon;
